<template>
  <el-watermark
    :content="watermarkContent"
    :font="{
      color: 'rgba(91, 155, 213, 0.1)',
      fontSize: 16
    }"
    :z-index="100"
    :gap="[150, 150]"
  >
    <div class="admin-layout">
    <!-- 左侧边栏 -->
    <aside class="admin-layout__sidebar" :class="{ 'admin-layout__sidebar--collapsed': sidebarCollapsed }">
      <!-- Logo 区域 -->
      <div class="admin-layout__logo">
        <div class="admin-layout__logo-icon">
        </div>
        <Transition name="logo-fade">
          <div v-if="!sidebarCollapsed" class="admin-layout__logo-text">
            <div class="admin-layout__logo-title">QRWiFi</div>
            <div class="admin-layout__logo-subtitle">管理后台</div>
          </div>
        </Transition>
      </div>

      <!-- 导航菜单 -->
      <nav class="admin-layout__nav">
        <HpsfirSideBar :model-value="false" :horizontal="false"  :fold="false">
          <template #footer>
            <div class="admin-layout__footer-version">
              <span class="version-main">v1.0.0</span>

            </div>
          </template>
        </HpsfirSideBar>
      </nav>
    </aside>

    <!-- 主内容区域 -->
    <div class="admin-layout__main">
      <!-- 顶部导航栏 -->
      <header class="admin-layout__header">
        <div class="admin-layout__header-left">
          <!-- todo -->
        </div>

        <div class="admin-layout__header-right">
          <!-- 用户信息 -->
          <HpsfirUserBar
            :enable-update-pw="true"
            :default-avatar="userStore.meta?.avatar ? `${useApi().baseUrl}${userStore.meta?.avatar}` : defaultAvatar"
          />
        </div>
      </header>

      <!-- 内容区域 -->
      <main class="admin-layout__content">
        <el-scrollbar>
          <router-view />
        </el-scrollbar>
      </main>
    </div>
  </div>
  </el-watermark>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { Expand, Fold } from '@element-plus/icons-vue';
import { HpsfirSideBar, HpsfirUserBar, useBaseUserStore } from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import defaultAvatar from '@/assets/avatar.png';

const route = useRoute();
const userStore = useBaseUserStore();

// 侧边栏折叠状态
const sidebarCollapsed = ref(false);

// 切换侧边栏
const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value;
};


// 水印内容：根据版本动态生成
const watermarkContent = computed(() => {
  const userName = userStore?.username || userStore.meta?.userName || userStore.meta?.name || '未登录用户';

  return [userName];
});
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
